import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { SubDomainService } from 'src/app/core/services/sub-domain.service';
import { SwitchOrganizationsService } from 'src/app/core/services/switch-organizations.service';

@Component({
  selector: 'app-switch-organizations',
  templateUrl: './switch-organizations.component.html',
  styleUrls: ['./switch-organizations.component.css']
})
export class SwitchOrganizationsComponent implements OnInit {

  orgList:any[] = JSON.parse(this._auth.getCookie('organizationsList')!) || [];
  selectedOrg:any;
  userObj:any = this._auth.getUserObj();
  loadingSubmit:boolean = false;
  prefixEndpoint:any;
  @ViewChild('confirmMessageComponent', {static: false}) confirmMessageComponent:any;
  @ViewChild('messageComponent', {static: false}) messageComponent:any;

  constructor(private _switchOrg:SwitchOrganizationsService,
    private _auth: AuthService,
    private _api: HttpService,
    private errHandle: ErrorHandlingService,
    private subdomainService:SubDomainService,
    private notificationService: NotificationsService,   
    private router: Router,
    private _permissionService:PermissionsService,) { }

  ngOnInit(): void {
    if(this.subdomainService.getUpdatedActiveSubdomain() || this._auth.getUserObj()?.sub_domain){
      this.prefixEndpoint = '/auth/';
    }else{
      this.prefixEndpoint = '/';
    }
  }

  showProfileMenu() {
    document
      .querySelector('.account-info-tab')
      ?.classList.add('show');
    document.querySelector('.overlay-navbar')?.classList.add('show');
    window.scrollTo(0, 0);
    // document.body.style.overflow = 'hidden';
  }

  closeProfileMenu() {
    document
      .querySelector('.account-info-tab')
      ?.classList.remove('show');
    document.querySelector('.overlay-navbar')?.classList.remove('show');
    // document.body.style.overflow = 'auto !important';
  }

  openConfirmMsgSwitchOrg(org:any){
    this.selectedOrg = org;
    this.confirmMessageComponent.open();
  }

  switchOrg(){
    this.loadingSubmit = true;
    let userObj = this._auth.getUserObj();
    let perviousUserType = this._auth.getUserType();
    // to switch account must use central token not current user token
    this._switchOrg.setCentralToken();
    userObj['sub_domain'] = this.selectedOrg?.domain;
    this._auth.setUserObj(userObj);
    this._api.getReq(`/organizations/switch`).subscribe(res=>{
      let user_type:string;
      let responsive:any = res;
      if(res?.data?.user?.has_required_forms){
        user_type = 'Onboard';
      }else{
        user_type = res?.data?.user?.user_type;
      }
      // before set new user object and token remove older user data
      this.removeOlderDataFromCookies();
      // remove central token from service
      this._switchOrg.removeCentralToken();
      // set new data
      this._auth.setUserType(user_type,true);
      let userObj = res?.data?.user;
      userObj['sub_domain'] = this.selectedOrg?.domain;
      this._auth.setUserObj(userObj,true);
      this._auth.setUserToken(res?.data?.access_token,true);
      // set new permissions
      this._api.getReq('/myPermissions').subscribe(res=>{
        if(res?.data?.length>0){
          this._permissionService.setUserPermissions(res?.data);
          if(perviousUserType==user_type){
            this.orgList = JSON.parse(this._auth.getCookie('organizationsList')!) || [];
            this.userObj = userObj;
            this.closeProfileMenu();
          }
          this._switchOrg.invokeUpdatedType({isSameType:perviousUserType==user_type,userType:user_type})
          this.navigate(user_type,responsive);
        }else{
          this.notificationService.warn('',"There are no permissions to access this system.")
          this._auth.signOut();
          this.loadingSubmit = false;
          this.confirmMessageComponent.close();
        }
      },err=>{
        this.errHandle.errorHandling(err);
        this.loadingSubmit = false;
        this._auth.signOut();
      })

    },err=>{
      this._switchOrg.removeCentralToken();
      // remove central token from service
      this._switchOrg.removeCentralToken();
      this.errHandle.errorHandling(err);
      this.loadingSubmit = false;
    }) 

  }

  navigate(user_type:any,res:any){
    this.confirmMessageComponent.close();
    this.loadingSubmit = false;
    this.notificationService.success('',res?.message);
    this.orgList = JSON.parse(this._auth.getCookie('organizationsList')!) || [];
    //navigate according to type of user
    if (res?.data?.user?.has_required_forms){
      this.router.navigate(['/onboarding']);
    }else if (res?.data?.user?.has_required_forms == 0 && user_type=="Agents"){
      this.router.navigate(["/third-parties/agent-dashboard/information"]);
    }else if(res?.data?.user?.has_required_forms == 0 && user_type=="Brokers"){
      this.router.navigate(["/third-parties/broker-dashboard/information"]);
    }else if(res?.data?.user?.has_required_forms == 0 && user_type=="Producers"){
      this.router.navigate(["/third-parties/producer-dashboard/information"]);
    }else if (res?.data?.user?.has_required_forms == 0 && user_type=="Dealers"){
      this.router.navigate(["/third-parties/dealer-dashboard/information"]);
    }
  }

  removeOlderDataFromCookies(){
    const userType = this._auth.getUserType();
    this._auth.deleteCookie(`fiGalaxyToken${userType}`);
    this._auth.deleteCookie(`fiGalaxyObj${userType}`);
  }

  accepted() {
    this.signOut();
  }

  rejected() {
    // this.showConfirmMessage = false;
    this.closeProfileMenu();
    this.messageComponent.close();
  }


  signOut() {
    this.loadingSubmit = true;
    this._api.getReq(`${this.prefixEndpoint}logout`).subscribe(
      (res) => {
        // this.showConfirmMessage = false;
        this.messageComponent.close();
        this.closeProfileMenu();
        this._auth.signOut();
        this.notificationService.success('', res.message);
        this.loadingSubmit = false;
      },
      (err) => {
        // this.showConfirmMessage = false;
        this.messageComponent.close();
        this.closeProfileMenu();
        this.errHandle.errorHandling(err);
        this.loadingSubmit = false;
      }
    );
  }


}
